import { createMessageName } from '@formkit/validation';
import { sentence, date, list } from '../formatters.mjs';

// packages/i18n/src/locales/hr.ts
var add = "Dodaj";
var remove = "Ukloni";
var incomplete = "Pojedina polja nisu ispravno ispunjena.";
var submit = "Predaj";
var moveUp = "Pomaknite se gore";
var moveDown = "Pomakni se dolje";
var isLoading = "Učitavanje...";
var loadMore = "Učitaj više";
var next = "Sljedeći";
var prev = "prijašnji";
var addAllValues = "Dodajte sve vrijednosti";
var addSelectedValues = "Dodavanje odabranih vrijednosti";
var removeAllValues = "Ukloni sve vrijednosti";
var removeSelectedValues = "Ukloni odabrane vrijednosti";
var chooseDate = "Odaberite datum";
var changeDate = "Promijeni datum";
var close = "Zatvoriti";
var open = "Otvori";
var accepted = function({
  name
}) {
  return `Potrebno je potvrditi ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} mora biti u periodu poslije ${date(args[0])}.`;
  }
  return `${sentence(name)} mora biti u budućnosti.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} mora sadržavati samo slova.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} mora sadržavati slova i brojeve.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} mogu sadržavati samo slova i razmake..`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} mora sadržavati abecedne znakove.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} mora sadržavati slova ili brojeve.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} mora sadržavati slova ili razmake.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} mora sadržavati simbol.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} mora sadržavati velika slova.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} mora sadržavati mala slova.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} mora sadržavati brojeve.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} mora biti simbol.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} može sadržavati samo velika slova.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} može sadržavati samo mala slova.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} mora biti prije ${date(args[0])}.`;
  }
  return `${sentence(name)} mora biti u prošlosti.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Format sadržaja nije ispravan i ne može biti predan.`;
  }
  return `${sentence(name)} mora biti između ${args[0]} i ${args[1]}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} ne odgovara zadanoj vrijednosti.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} nije ispravan format datuma. Molimo koristite sljedeći format: ${args[0]}`;
  }
  return "Ovo polje nije ispravno postavljeno i ne može biti predano.";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} mora biti vrijednost između ${date(args[0])} i ${date(args[1])}`;
};
var email = "Molimo upišite ispravnu email adresu.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} ne završava s ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} nije dopuštena vrijednost.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = first <= second ? first : second;
  const max2 = second >= first ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} mora sadržavati barem jedan znak.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} mora imati ${max2} ili manje znakova.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} trebao bi biti dugačak ${max2} znakova.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} mora imati barem ${min2} znakova.`;
  }
  return `Broj znakova za polje ${sentence(name)} mora biti između ${min2} i ${max2}.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} nije dozvoljena vrijednost.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Ne smije imati više od ${args[0]} ${name} polja.`;
  }
  return `${sentence(name)} mora imati vrijednost manju ili jednaku ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Format datoteke nije dozvoljen.";
  }
  return `Format datoteke na polju ${sentence(name)} mora odgovarati: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Broj upisanih vrijednosti na polju ${name} mora biti barem ${args[0]}.`;
  }
  return `${sentence(name)} mora biti barem ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” nije dozvoljena vrijednost na polju ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} mora biti broj.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" ili ")} je potreban.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} je obavezno.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} ne počinje s ${list(args)}.`;
};
var url = function() {
  return `Unesite valjanu URL adresu.`;
};
var invalidDate = "Odabrani datum je nevažeći.";
var ui = {
  add,
  remove,
  incomplete,
  submit,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var hr_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, hr_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, not, number, open, prev, remove, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=hr.mjs.map